export default __webpack_public_path__ + "static/media/Beard_8_C4.8c646537.svg";